import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAnglesLeft, faAnglesRight } from '@fortawesome/free-solid-svg-icons'
import './verticalNav.css'
import {
  VAPermissions,
  elements as defaultElements,
} from '../../Utils/constants'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import useValidatePermission from 'Hooks/useValidatePermission'
import useHandleElements from 'Hooks/useHandleElements'

function VerticalNav(props) {
  const location = useLocation()
  const [openCalc, setOpenCalc] = useState(false)
  const revealRefs = useRef([])

  revealRefs.current = []
  const isCustomer = useSelector(state => state.login.isCustomer)

  const canUseWebDocuments = useValidatePermission(
    VAPermissions.canUseWebDocuments
  )

  const elements = useHandleElements({
    defaultElements,
  })

  const handleModal = () => {
    setOpenCalc(!openCalc)
  }

  const textCheck = () => {
    if (props.isOpen) {
      revealRefs.current.map(element => {
        return (element.style.display = 'block')
      })
    } else {
      revealRefs.current.map(element => {
        return (element.style.display = 'none')
      })
    }
  }

  const addToRef = el => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el)
    }
  }

  const handleMenuOpenItem = (e, item) => {
    props.setSelectedOption(item)
    props.setIsOpen(false)

    e.preventDefault()
    if (props.menuOpenItem.includes(item.title)) {
      props.setMenuOpenItem(props.menuOpenItem.filter(i => i !== item.title))
    } else {
      props.setMenuOpenItem([...props.menuOpenItem, item.title])
    }
  }

  const isActiveRoute = (element, pathname) => {
    if (typeof element.link === 'string' && element.link === pathname) {
      return true
    }

    if (
      typeof element.link === 'object' &&
      element.link.pathname === pathname
    ) {
      return true
    }

    if (element.children) {
      return element.children.some(child =>
        child.grandChildren?.some(grand =>
          typeof grand.link === 'string'
            ? grand.link === pathname
            : grand.link?.pathname === pathname
        )
      )
    }

    return false
  }

  // Función para evaluar si mostrar el badge
  const shouldShowBadge = (isOpen, menuOpenItem) => {
    return isOpen && (menuOpenItem.length > 0 || isOpen)
  }

  // Función para renderizar el badge "Nuevo"
  const renderNewBadge = (
    isOpen,
    menuOpenItem,
    className = 'badge-color',
    style = {}
  ) => {
    return shouldShowBadge(isOpen, menuOpenItem) ? (
      <p className={className} style={style}>
        Nuevo
      </p>
    ) : null
  }

  useEffect(() => {
    textCheck()
  }, [props.isOpen])

  // get breakpoints frpm material ui

  return (
    <div data-testid="vertical-nav-wrapper">
      <Box
        className="vertical-navbar"
        component="nav"
        data-testid="vertical-nav"
        sx={{
          width: {
            xs: props.isOpen ? '200px' : '0px',
            sm: !props.isOpen ? '70px' : '320px',
          },
          display: { xs: props.isOpen ? 'block' : 'none', sm: 'block' },
        }}>
        <ul className="nav-icons-container" data-testid="container-nav-icons">
          <Box
            display="flex"
            justifyContent={props.isOpen ? 'flex-end' : 'center'}
            onClick={props.handleDrawer}
            className="v-nav-icon"
            data-testid="btn-toggle-nav">
            <FontAwesomeIcon
              className="sp open"
              icon={props.isOpen ? faAnglesLeft : faAnglesRight}
            />
          </Box>
          {elements.map(element => {
            if (isCustomer && element.hiddenByClient) return null
            return !element.isCalculator ? (
              <Link
                key={element.title}
                {...(element.link ? { to: element.link } : {})}
                className="v-nav-icon"
                data-testid={`link-nav-${element.id}`}
                {...(!element.link
                  ? { onClick: e => handleMenuOpenItem(e, element) }
                  : {})}
                style={{
                  backgroundColor: isActiveRoute(element, location.pathname)
                    ? '#022767'
                    : 'transparent',
                }}>
                <li
                  className={
                    props.isOpen
                      ? 'v-nav-icon-content-open'
                      : 'v-nav-icon-content'
                  }>
                  <img
                    src={element.image}
                    alt="nav"
                    style={{
                      filter: isActiveRoute(element, location.pathname)
                        ? 'invert(53%) sepia(86%) saturate(459%) hue-rotate(140deg) brightness(107%) contrast(80%)'
                        : 'grayscale(100%)',
                    }}
                  />
                  <p
                    className="link-text"
                    ref={addToRef}
                    style={{
                      color:
                        isActiveRoute(element, location.pathname) && '#21C5DF',
                    }}>
                    {element.title}
                  </p>
                  {element.title === 'Plantilla de precios' &&
                    renderNewBadge(props.isOpen, props.menuOpenItem)}
                  {element.title === 'Reportes' &&
                    renderNewBadge(
                      props.isOpen,
                      props.menuOpenItem,
                      'title-new',
                      {
                        color: openCalc && '#21C5DF',
                      }
                    )}
                  {element.title === t('DISPATCH_ORDER_T.ORDER_TRACKING') &&
                    renderNewBadge(props.isOpen, props.menuOpenItem)}
                  {element.title === 'Servicio de instalación' &&
                    renderNewBadge(props.isOpen, props.menuOpenItem)}
                </li>
              </Link>
            ) : (
              <div
                key={element.title}
                to={element.link}
                className="v-nav-icon"
                data-testid={`link-nav-${element.id}`}
                style={{
                  backgroundColor: openCalc ? '#022767' : 'transparent',
                }}
                onClick={handleModal}>
                <li
                  className={
                    props.isOpen
                      ? 'v-nav-icon-content-open'
                      : 'v-nav-icon-content'
                  }>
                  <img
                    src={element.image}
                    alt="nav"
                    style={{
                      filter: openCalc
                        ? 'invert(53%) sepia(86%) saturate(459%) hue-rotate(140deg) brightness(107%) contrast(80%)'
                        : 'grayscale(100%)',
                    }}
                  />
                  <p
                    className="link-text"
                    ref={addToRef}
                    style={{
                      color: openCalc && '#21C5DF',
                    }}>
                    {element.title}
                  </p>
                </li>
              </div>
            )
          })}
        </ul>
      </Box>
      {props.menuOpenItem.includes(props.selectedOption.title) && (
        <Box
          className="vertical-navbar-submenu"
          component="nav"
          data-testid="container-vertical-nav-submenu"
          style={{ left: props.isOpen ? '300px' : '70px' }}
          sx={{
            width: {
              xs: props.isOpen ? '200px' : '200px',
              sm: props.isOpen ? props.drawerWidth : '320px',
            },
          }}>
          {elements
            .filter(
              element =>
                element.title === props.selectedOption.title &&
                element.children?.length > 0
            )
            .map(element => (
              <div key={element.title} className="v-nav-icon-submenu">
                <li className="v-nav-icon-content-open">
                  <p className="link-text-submenu">{element.title}</p>
                </li>
                <hr className="line-separator"></hr>
                <ul
                  className="v-nav-icon-children-submenu"
                  style={{
                    // check if the item is open and if is included in the props.menuOpenItem array
                    display: props.menuOpenItem.includes(element.title)
                      ? 'block'
                      : 'none',
                  }}>
                  {element.children.map(child => (
                    <p
                      key={child.title}
                      className="v-nav-icon-submenu-children">
                      {child.title && (
                        <span className="link-text-submenu-section">
                          {child.title}
                        </span>
                      )}
                      <li className="v-nav-icon-content-open-submenu">
                        {child.grandChildren?.length > 0 &&
                          child.grandChildren.map(grandChild => {
                            if (
                              grandChild.title === 'Orden de venta web' &&
                              !canUseWebDocuments
                            )
                              return null
                            return (
                              <Link
                                key={grandChild.title}
                                to={grandChild.link}
                                className="v-nav-icon-submenu-grandchildren"
                                data-testid={`link-nav-submenu-${grandChild.id}`}
                                style={{
                                  backgroundColor:
                                    grandChild.link === location.pathname
                                      ? '#003082'
                                      : undefined,
                                }}>
                                <li className="v-nav-icon-content-open-submenu-grandchildren">
                                  <img
                                    src={grandChild.image}
                                    alt="nav"
                                    className={
                                      grandChild.link === location.pathname
                                        ? 'img-invert'
                                        : ''
                                    }
                                  />
                                  <p
                                    className="link-text-submenu-grandchildren"
                                    style={{
                                      color:
                                        grandChild.link === location.pathname
                                          ? '#FFF'
                                          : undefined,
                                    }}>
                                    {grandChild.title}
                                  </p>
                                </li>
                              </Link>
                            )
                          })}
                      </li>
                    </p>
                  ))}
                </ul>
              </div>
            ))}
        </Box>
      )}
    </div>
  )
}

export default VerticalNav
